import React from 'react';
import { Form } from '../../../ui/universe';
import SafeMathJax from '../../../ui/SafeMathJax';
import { getSelectRectKey } from '../utils';

/**
 * Math 渲染器 - 用于数学公式展示
 * @param {Object} props
 * @param {Object} props.params - OCR 响应参数
 * @param {Object} props.config - 结果配置
 * @param {Object} props.detail - 菜单详情配置
 * @param {string} props.selectRect - 当前选中的矩形 key
 * @param {Function} props.onSelect - 选中回调
 */
const MathRenderer = ({ params, config, detail, selectRect, onSelect }) => {
  return (
    <>
      {params[config.firstField]?.map((i, index) => {
        const selectRectVal = getSelectRectKey({
          data: i,
          key: detail?.rectConfig?.RectKey,
          valStr: i[config.secondField]
        });

        return (
          <Form.Item
            className={`math-container ${selectRect && selectRect === selectRectVal ? 'isSelect' : ''} list`}
            key={index}
            label=""
            onClick={() => {
              onSelect && onSelect(i[config.secondField], selectRectVal);
            }}
          >
            {i[config.secondField] && (
              <SafeMathJax>
                {i[config.secondField]}
              </SafeMathJax>
            )}
          </Form.Item>
        );
      })}
    </>
  );
};

export default MathRenderer;
